import { useCookieConsent } from '@packages/utilities';
import { useEffect } from 'react';
import { useTracking } from '../../../hooks';
import { ExternalScriptTestIds } from '../types';

/**
 * This component represents external JavaScript resources to be used on content pages.
 * This component delivers product content generated by HappyContest.
 *
 * @param src String contains happy Contest Source
 * @param id String contains happy Contest Identifier
 * @returns JSX.Element to be placed in PageLayout
 */
export const HappyContest = ({ src, id }: { src: string; id: string }) => {
  const isAllowed: boolean = useCookieConsent('C0004');
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (isAllowed) {
      dispatchGTMEvent({
        event: 'RenderHappyContest',
        happyContestSrc: src,
      });
    }
  }, [dispatchGTMEvent, isAllowed, src]);

  return isAllowed ? (
    <div data-testid={ExternalScriptTestIds.HappyContestScript} id={id} />
  ) : (
    <div data-testid={ExternalScriptTestIds.HappyContestScriptNotAllowed} />
  );
};
